<template>
  <div class="card-sty">
              <router-link
            :to="{ name: 'DairyMonitoring', params: { macId: properties.machine_id } }"
            style="text-decoration: none"
          >
<v-card 

   style="   border-width: 10px;    " 
>

    <v-card
    align="center"

      class="item1 card-center border border-primary"
            v-bind:class="{
            okClass: properties.hasAlert == 0,
            alertClass: properties.hasAlert == 1,
          }"
      id="gauge-card"
      :min-width="properties.maxwidth"
      :min-height="properties.maxheight"
   
    >
                    <v-row align="left" class="ml-1">
                <!-- <v-icon class="text-bule">icon-dpimm</v-icon> -->
                
                <div v-if="properties.state" class="ml-1">
                    <v-btn class="mx-0 white--text"
      fab
      x-small
      
       color="green" 
:style="{left: '0%',marginBottom: '5px',marginTop: '5px'}" >ON  </v-btn>

    </div>
        <div v-if="!properties.state" class="ml-1">
                    <v-btn class="mx-0 white--text"
      fab
      x-small
       color="red" 
:style="{left: '0%',marginBottom: '5px',marginTop: '5px'}" > OFF </v-btn>

    </div>
                <v-card-title class="font-weight-bold text-bule pt-0 pb-0"
                  >        
                  <!-- <vue-custom-tooltip :label="machine"> -->
          <!-- <h2> -->
            {{properties.machine_name}}

          <!-- </h2> -->
        <!-- </vue-custom-tooltip> -->
        </v-card-title
                >

              </v-row>
      <v-card-text style='margin-bottom: -10px '>
                        

              <v-row align="center" class="mb-1 mt-1 border-bottom pb-3" v-for="each_param_dic in properties.parameters" :key="each_param_dic.name">
                <div class="text-grey pl-md-10  font-weight-bold ">
                  
                    {{each_param_dic.name}} --
                  
                  </div>
                  <div v-if="each_param_dic.value=='OPEN'" class="text-red pl-md-5 font-weight-bold ">
                  
                    {{each_param_dic.value}} 
                 
                </div>
                <div v-else-if="each_param_dic.value=='CLOSED'" class="text-success pl-md-5 font-weight-bold ">
                  
                  {{each_param_dic.value}} 
               
              </div>
                <div v-else class="text-blue pl-md-5 font-weight-bold ">
                  
                  {{each_param_dic.value}} 
               
              </div>
               
              </v-row>
     <v-row>
                <v-col>
                 <h6 align='right' class="align-self-end" style='margin-bottom: -30px;'> {{timeConverter(properties.time)}}</h6>
                </v-col>
                </v-row>
               <!-- <v-row align="center" class="mb-1">
                              <div class="text-bule pr-lg-3 pr-xl-4">
                  <div class="font-weight-bold transition-swing text-h6">
                    Door
                  </div>
                </div>
                </v-row> -->
                        

      </v-card-text>
       <v-card-actions>
              
    </v-card-actions>
    <!-- <v-card-footer>
                       <h6 align='right' class="align-self-end" style='margin-bottom: -30px;'> {{timeConverter(properties.time)}}</h6>

    </v-card-footer> -->
    </v-card>
  
    </v-card>
                  </router-link >
  </div>
</template>

<script>
// import VueApexCharts from "vue-apexcharts";
      // import router from "../router";

export default {
  name: "dpm_card",
  props: ["gag",'properties'],
  components: {
    // apexchart: VueApexCharts,
  },
  
  data: function() {
    return {
      //message: 'time to update',
      //unit: 'unit',
      //component_name: "name",
      //series: [76],
      isEnergy: "true",
      
      chartOptions: {
        chart: {
          type: "radialBar",
          offsetY: -20,
          sparkline: {
            enabled: true,
          },
        },
        // title: {
        //   text: this.gag.component_name,
        //   align: "center",
        //   style: {
        //     color: "#484848",
        //     // fontFamily: "EMPrint",
        //     marginTop:"-5px;",
        //     fontSize: "18px",
        //     fontWeight: "bold",
        //   },
        // },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            //                                  hollow: {
            //                  margin: 0,
            //                  size: '70%',
            //                background: '#fff',
            //              image: undefined,
            //            imageOffsetX: 0,
            //          imageOffsetY: 0,
            //        position: 'front',
            //      dropShadow: {
            //        enabled: true,
            //        top: 3,
            //        left: 0,
            //        blur: 4,
            //        opacity: 0.24
            //     }
            //   },
            track: {
              background: "#e7e7e7",
              strokeWidth: "90%",
              margin: 5, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: "#999",
                opacity: 1,
                blur: 2,
              },
            },
            dataLabels: {
              textAnchor: "middle",
              name: {
                // show: false,
                name: {
                  fontSize: "18px",
                  offsetY: -50,
                  color: "#222222",
                },
              },
              value: {
                offsetY: -2,
                fontSize: "0px",
                formatter: function(val) {
                  return val + "%";
                },
              },
            },
          },
        },
        //grid: {
        //padding: {
        //top: -10,
        //},
        //},
        fill: {
          // type: "gradient",
          colors: ["#002080"],
          //       gradient: {
          //       shade: "dark",
          //     shadeIntensity: 0.4,
          //   inverseColors: false,
          // opacityFrom: 1,
          //opacityTo: 1,
          //stops: [0, 50, 53, 91],
          // },
        },
        // stroke: {
        //   dashArray: 4
        //    },
        labels: [""],
      },
    };
  },
  methods: {
    
         timeConverter: (UNIX_timestamp) => {
      // let a = new Date(UNIX_timestamp * 1000);
      // console.log(" in time converter " , UNIX_timestamp);
      let a = new Date((UNIX_timestamp *1000) );
      // console.log(" in time converter a " , a);
      let months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      let year = a.getFullYear();
      let month = months[a.getMonth()];
      let date = a.getDate();
      let hour = a.getHours();
      let min = a.getMinutes();
      let sec = a.getSeconds();
      let time =
        date + " " + month + " " + year + " " + hour + ":" + min + ":" + sec;
        // console.log(" in time converter time " , time);
      return time;
    },
    
    // goingIntoCustomer (){
    //   console.log("checkign id",this.properties.machine_id);
    //                                     sessionStorage.removeItem("route_first_option");

    //                     sessionStorage.setItem("route_first_option", '/');
    //                     sessionStorage.setItem("super_to_user_org_id", `${this.properties.machine_id}`);


    //   router.push('/')

    //             //  this.$root.$emit('value_of_checkbox', gag.customer_id);

    // }
  }
};
</script>

<style scoped>
@import "../assets/fonts/style.css";

/* #gauge-card { */
  /* border-style: solid ;
  border-radius: 15px;
    border-color: #a7a7a7; */
/* } */
.item2 {
  font-family: "EMPrint";
  font-size: 16px;
  font-weight: bold;
}
.minClass {
  font-size: small;
  font-weight: bolder;
  text-align: center;
  /* top bottom left right */
  margin: -20px 50px -5px -30px; 
}
.minClass1 {
  font-size: small;
  font-weight: bolder;
  text-align: center;
    /* top bottom left right */

  margin: -20px 140px -5px -30px;
}
.maxClass {
  font-size: small;
  font-weight: bolder;
  text-align: center;
    /* top bottom left right */

  margin: -22px -200px 0px -140px;
}
.maxClass1 {
  font-size: small;
  font-weight: bolder;
  text-align: center;
    /* top bottom left right */

  margin: -22px -300px 0px -140px;
}
.okClass {
  /* border-right: 10px solid green; */
  /* border-top: 10px  solid green; */
  border-left: 10px solid green;
  /* background-color: #50fe009a; */
  
}
.alertClass {
  /* border-right: 10px solid red; */
  border-left: 10px  solid red;
  /* border-top: 10px  solid red; */
  /* background-color: #FE000C; */
}
@media screen and (max-width: 600px)  {
.card-sty{
  width: 350px
}

}

</style>
